var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.8,
    y: 0.8,
    width: 10.4,
    height: 12.4,
    rx: 1.2,
    fill: "none",
    stroke: "white",
    strokeOpacity: 0.85,
    strokeWidth: 1.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.5H9",
    stroke: "white",
    strokeOpacity: 0.85,
    strokeWidth: 1.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 8H9",
    stroke: "white",
    strokeOpacity: 0.85,
    strokeWidth: 1.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 10.5H7",
    stroke: "white",
    strokeOpacity: 0.85,
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.794cffdf121e272706b80e1336946d2d.svg";
export { ForwardRef as ReactComponent };